import { createTheme } from '@mui/material/styles';
import { colors } from './colors';
import { selectDarkTheme } from './darkTheme';

// Extends the existing (narrow) selectDarkTheme with a real dark palette + fonts,
// so Paper/Typography/x-charts inherit dark surfaces (fixes the white drawer) and
// text uses Inter/Archivo like the rest of the app (fixes the typography mismatch).
export const dashboardDarkTheme = createTheme(selectDarkTheme, {
  palette: {
    mode: 'dark',
    background: {
      default: colors.background.primary, // #212121
      paper: '#242424',
    },
    text: {
      primary: colors.primary.white,
      secondary: '#9aa0a6',
    },
  },
  typography: {
    fontFamily: 'inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h1: { fontFamily: 'archivo, inter, sans-serif' },
    h2: { fontFamily: 'archivo, inter, sans-serif' },
    h3: { fontFamily: 'archivo, inter, sans-serif' },
    h4: { fontFamily: 'archivo, inter, sans-serif' },
    h5: { fontFamily: 'archivo, inter, sans-serif' },
    h6: { fontFamily: 'archivo, inter, sans-serif' },
    subtitle1: { fontFamily: 'archivo, inter, sans-serif' },
  },
});
